/**
 * @file Components/Sections/About.jsx
 * @description About section component displaying company information,
 * mission statement, and key statistics with animated visuals.
 */

import React from 'react';
import PropTypes from 'prop-types';

const About = ({ title = "About Us", content, stats = [] }) => {
  const defaultStats = [
    { number: "10+", label: "Years Experience" },
    { number: "1000+", label: "Happy Customers" },
    { number: "50+", label: "Destinations" },
    { number: "24/7", label: "Support" }
  ];

  const statsToShow = stats.length > 0 ? stats : defaultStats;

  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            {title}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-lg text-gray-600 mb-6">
              {content || "We are passionate about creating unforgettable travel experiences. With years of expertise in the travel industry, we specialize in crafting personalized journeys that exceed expectations."}
            </p>
            <p className="text-lg text-gray-600 mb-6">
              Our team of travel experts is dedicated to providing exceptional service, ensuring every detail of your trip is perfectly planned and executed.
            </p>
            <div className="flex flex-wrap gap-4">
              <button className="bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition-colors duration-200">
                Learn More
              </button>
              <button className="border border-blue-600 text-blue-600 px-6 py-3 rounded-md hover:bg-blue-50 transition-colors duration-200">
                Contact Us
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6">
            {statsToShow.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-600">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

About.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  )
};

export default About;
